import React from 'react';

const Loader = () => {
  return (
    <div
    className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 flex-col"
    style={{ backgroundColor: 'rgba(255, 245, 245, 0.9)' }} // Warm white with transparency
  >  <img
        src="/Images/Loading_HSC.gif" // Replace with your local GIF path
        alt="Loading..."
        className="w-64 h-64 mb-2" // Add margin-bottom to create space between GIF and text
      />
      <p className="text-lg font-bold text-black ml-4">Processing...</p>
    </div>
  );
};

export default Loader;
